import { createSlice } from '@reduxjs/toolkit';
import { GET_COMMITTEE_REVIEWERS } from '../../../actions-index';
import { ERROR_CONSTS } from '../../../util/constants';

// ---------------------------------------------------------------------------
// committeeReviewerReducer slice
// ---------------------------------------------------------------------------
const committeeReviewerInitialState = {
  reviewers: {
    status: '',
    alert: ERROR_CONSTS.UI.GENERIC.EMPTY_ALERT,
    type: GET_COMMITTEE_REVIEWERS,
  },
};

const committeeReviewerSlice = createSlice({
  name: 'committeeReviewerReducer',
  initialState: committeeReviewerInitialState,
  reducers: {
    getCommitteeReviewers(state, action) {
      return {
        ...state,
        reviewers: {
          status: action.payload.status,
          alert: action.payload.alert,
          data: action.payload.data || [],
          type: GET_COMMITTEE_REVIEWERS,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GET_COMMITTEE_REVIEWERS, (state, action) => {
      return {
        ...state,
        reviewers: {
          status: action.payload.status,
          alert: action.payload.alert,
          data: action.payload.data || [],
          type: GET_COMMITTEE_REVIEWERS,
        },
      };
    });
  },
});

export const { getCommitteeReviewers } = committeeReviewerSlice.actions;
export const committeeReviewerReducer = committeeReviewerSlice.reducer;
